import UpsellModal from './UpsellModal';

export { UpsellModal as default };
